// step-1
export const propertyRightsDetails = [
  {
    label: 'מידע מפורט',
    value: 'מיקום הנכס תואם לתשריט הבית המשותף.\n' +
      'קיימת התאמה בין שווי הנכס המוערך לזכויות המשפטיות המוצעות לשעבוד.'
  },
]
export const rightsPermitCompanyMeshakenet = [
  {
    label: 'מידע מפורט',
    value: '• תאריך:\n' +
      '• בעלי הזכויות:\n' +
      '• פרטי הנכס: ( גוש, חלקה, מס\' מגרש, מס\' בנין, מס\' דירה, קומה, כיווני אוויר, מס\' חדרים).\n' +
      '• הצמדות:\n' +
      '• הערות (משכנתה וכו\'..).'
  },
]
export const rightsPermitRami = [
  {
    label: 'מידע מפורט',
    value: '• תאריך:\n' +
      '• בעלי הזכויות:\n' +
      '• פרטי הנכס: (גוש, חלקה, מגרש בהתאם לתב"ע)\n' +
      '• תיאור הנכס: (דירה, מס\' חדרים - כולל שטחים)\n' +
      '• הצמדות:\n' +
      '• הערות ( משכנתאות וכו\'..).'
  },
]
export const rightsPermitOther = [
  {
    label: 'מידע מפורט',
    value: '• תאריך:\n' +
      '• בעלי הזכויות:\n' +
      '• פרטי הנכס: (גוש, חלקה, מס\' מגרש, מס\' בנין, מס\' דירה, קומה, כיווני אוויר, מס\' חדרים).\n' +
      '• הצמדות:\n' +
      '• הערות (משכנתה וכו..).'
  },
]
export const notesText = [
  {
    label: 'העברה לזרים',
    value: 'רשומה הערה בדבר העברה לזרים לטובת מדינת ישראל'
  },
  {
    label: 'ס\' 126',
    value: 'רשומה הערת אזהרה ס\' 126 לטובת'
  },
  {
    label: 'תקנה 27',
    value: 'רשומה הערה על יעוד מקרקעין תקנה 27 לטובת'
  },
  {
    label: 'תקנה 29',
    value: 'רשומה הערה על אי התאמה תקנה 29 לטובת'
  },
  {
    label: 'אזהרה תמ"א 38',
    value: 'רשומה הערת אזהרה תמ"א 38 לטובת'
  },
  {
    label: 'הסכם שיתוף',
    value: 'רשומה הערה בדבר הסכם שיתוף'
  },
  {
    label: 'הפקעה ס\' 19',
    value: 'רשומה הערה על הפקעת חלק מחלקה ס\' 19 לטובת'
  },
  {
    label: 'הפקעה סעיפים 5 ו-7 ',
    value: 'רשומה הערה על הפקעה סעיפים 5 ו-7 לטובת'
  },
  {
    label: 'אתר עתיקות',
    value: 'רשומה הערה בדבר אתר עתיקות'
  },
  {
    label: 'זיקת הנאה',
    value: 'רשומה זיקת הנאה על החלקה'
  },

]

//step-3
export const houseFinishGradeDesc = [
  {
    label: 'מידע מפורט',
    value: '-סורגים: יש/אין/חלקי\n' +
      '-קירות גבס/ בלוקים\n' +
      '-חלונות עץ/ אלומיניום\n' +
      '-קירות גבס/ בלוקים\n' +
      '-תריסים רגיל/ גלילה (חשמלי/ידני)\n' +
      '-דלתות כניסה פלדלת/ מחוסמת\n' +
      '-דלתות פנים עץ\n' +
      '-מזגנים מפוצלים/ מזגן חלקי/ מרכזי/ הסקה\n' +
      '-דוד שמש/ חשמל\n' +
      '-סלון\n' +
      '-ריצוף בסלון: בהיר/ כהה\n' +
      '-מסוג טרצו/ קרמיקה/ שיש/ שטיח\n' +
      '-בגודל  20*20/ 30*30/ 30*60/ 40*40\n' +
      '-חדרים\n' +
      '-ריצוף בחדרים: בהיר/כהה\n' +
      '-מסוג טרצו/קרמיקה/שיש/שטיח/גרניט פורצלן\n' +
      '-בגודל 20*20/ 30*30/ 30*60/ 40*40\n' +
      '-מטבח\n' +
      '-חיפוי חרסינה/ קרמיקה/ שיש/ רגיל/ מודרני/ אין\n' +
      '-ריצוף טרצו/ קרמיקה/ שיש\n' +
      '-בגודל  20*20/ 30*30/ 30*60/ 40*40\n' +
      '-משטח שיש/ גרניט/ אבן קיסר/ חברון\n' +
      '-ארונות קומפלט/ עיליים בלבד/ תחתונים בלבד/ אין\n' +
      '-עשויים מעץ/ פורמאיקה/ מלאמין\n' +
      '-במצב מעולה/ טוב/ רגיל/ בינוני/ גרוע\n' +
      '-סוג מטבח\n' +
      '-חלונות אלומיניום\n' +
      '-מקלחת/ אמבטיה/שירותים/ג\'קוזי/ חדר רחצה/ חדר רחצה ושירותים\n' +
      '-חיפוי חרסינה/ קרמיקה/ אין, מלא/ חלקי\n' +
      '-ריצוף טרצו/ קרמיקה\n' +
      '-בגודל  20*20/ 30*30/ 30*60/ 40*40\n' +
      '-ארונות: יש/ אין'
  },
  {
    label: 'הנחיה מקוצרת',
    value: '\n' +
      '-חלונות אלומיניום/עץ\n' +
      '-דלת כניסה פלדלת\n' +
      '-דלתות פנים עץ\n' +
      '-מיזוג מרכזי/מפוצל\n' +
      '-ריצוף\n' +
      '-ריצוף וחיפוי קרמי בחדרי הרחצה והשירותים\n' +
      '-מטבח קומפלט'
  }
]

//step-4
export const envDevelopmentLevel = [
  {
    label: 'פיתוח מלא',
    value: 'קיים פיתוח סביבתי מלא'
  },
  {
    label: 'פיתוח חלקי',
    value: 'קיים פיתוח סביבתי חלקי'
  },
  {
    label: 'פיתוח חלקי 2',
    value: 'קיים פיתוח סביבתי חלקי - תוואי כבישים סלולים חלקית'
  },
]

//step-8
export const getPropertyLocation = (cityName) => {
  return [
    {
      label: 'טקסט לדוגמה',
      value: `מיקומו של הנכס במרקם הכללי של ${cityName ? cityName : ''}. אופי האזור, רמת הפיתוח הקיימת והנגישות לנכס.`
    }
  ]
}

export const propertyProperties = [
  {
    label: 'טקסט לדוגמה',
    value: 'מאפייני הנכס לרבות שטח הנכס, צורתו, מצבו הפיזי והפחת שנצבר. הובא בחשבון כי המבנה הקיים תורם לשווי הקרקע.'
  }
]

export const planningBackground = [
  {
    label: 'טקסט לדוגמה',
    value: 'מצבו התכנוני של הנכס.'
  }
]

export const possessoryBackground = [
  {
    label: 'טקסט לדוגמה',
    value: 'הרקע הקנייני.'
  }
]

export const areaPropertiesPrices = [
  {
    label: 'טקסט לדוגמה',
    value: 'ההיצעים והביקושים בסביבה לסוג זה של נכסים בתקופת התאריך הקובע תוך ביצוע ההתאמות הנדרשות לנכס הנדון.'
  }
]

export const getAdditionalStatements = (bankName) => {
  return [
    {
      label: 'אינה ביקורת הנדסית',
      value: 'חוות הדעת אינה מהווה ביקורת הנדסית. הח"מ אינו מודד או מהנדס וחריגות הבניה, אם וקיימות, הינן מהתרשמות כללית בלבד, ללא בדיקה באמצעי מדידה מקצועיים.'
    },
    {
      label: 'שומה עבור המזמין בלבד',
      value: 'שומה זו הוכנה עבור מזמינה ולמטרתו בלבד. אין היא מהווה תחליף ליעוץ משפטי ואין להסתמך עליה לכל מטרה אחרת. השימוש בשומה נאסר על כל צד שלישי שהוא אשר אינו המזמין, ועורך השומה לא יהיה אחראי להסתמכות כלשהיא כאמור.'
    },
    {
      label: 'שווי כולל מע"מ',
      value: 'השווי כולל מע"מ, במידה וחל.'
    },
    {
      label: 'נועד רק לגוף המלווה',
      value: `חוות דעת זו נועדה אך ורק ל${bankName} ואין לעשות בה כל שימוש אחר.`
    },
  ]
};

//step-12
export const taxAndCostDesc = [
  {
    label: 'מידע בסיסי',
    value: 'לא הובאו בחשבון, במידה ויחולו'
  },
]
export const selfBuildDesc = [
  {
    label: 'הכוונה לבנק',
    value: 'א.  שווי המגרש (ללא עלויות הבניה):\n' +
      'ב.  מחיר הרכישה:\n' +
      'ג.  שטח הבניה:  שלב הבניה:\n' +
      'ד.  עלות הבניה:\n' +
      'ה.  סטנדרט הבניה הצפוי (בהתאם לפרטים שהתקבלו מהלקוח):\n' +
      'ו.  אומדן שווי המגרש + עלות הבניה במצב הנוכחי:\n' +
      'ז.  עלויות הבניה שהושקעו בנכס עד כה:\n' +
      'ח.  אומדן עלויות צפוי לסיום הבניה:\n' +
      'ט.  סה"כ שווי המגרש + עלות בניה צפויה בקבלת טופס 4:\n' +
      'י.  שווי הנכס הצפוי בסיום הבניה לאחר קבלת טופס 4:'
  },
]
export const renovationCostDesc = [
  {
    label: 'הכוונה לבנק',
    value: 'א.  אומדן שווי הנכס במצבו הנוכחי (התחלת השיפוץ):\n' +
      'ב.  עלויות השיפוץ שהושקעו בנכס עד כה:\n' +
      'ג.  אומדן עלויות השיפוץ  לסיום השיפוץ:\n' +
      'ד.  סה"כ שווי הנכס  + עלות השיפוץ:\n' +
      'ה.  שווי השוק של הנכס בסיום השיפוץ:'
  },
]
